import { rootActions, useAppDispatch, useAppSelector } from '../data/store';

const RadioTabs = () => {
    const dispatch = useAppDispatch();
    const isUserTabSelected = useAppSelector(store => store.root.isUserTabSelected);

    return (
        <div className="flex items-center mb-6">
            <label className="flex items-center mr-4">
                <input
                    type="radio"
                    name="type"
                    className="mr-2"
                    checked={ isUserTabSelected }
                    onChange={ () => {
                        dispatch(
                            rootActions.main({
                                isUserTabSelected: true,
                                isSuccess: false,
                            })
                        );
                    }}
                />
                <span>Username</span>
            </label>
            <label className="flex items-center">
                <input
                    type="radio"
                    name="type"
                    className="mr-2"
                    checked={ !isUserTabSelected }
                    onChange={ () => {
                        dispatch(
                            rootActions.main({
                                isUserTabSelected: false,
                                isSuccess: false,
                            })
                        );
                    }}
                />
                <span>Email</span>
            </label>
        </div>
    )
};

export default RadioTabs;